import ptBRMessages from '../bbui/i18n/pt_BR';
export default ptBRMessages;